/* eslint-disable no-undef */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
__webpack_public_path__ = `${window.grLpsInitialData.cdn}javascripts/core/lps/dist/`;
